import { Component, Input } from "@angular/core";
import { input } from "@kpmg-tax/ui";
import { IFavoriteStudies } from "../models/study.model";
import { SessionService } from "src/app/shared/session-service/session.service";
import { Router } from "@angular/router";
import { ROUTE_URL } from "src/app/shared/constants/route-constants";

@Component({
    selector: 'rcn-favorite-studies',
    templateUrl: './favorite-studies.component.html',
    styleUrls: ['./favorite-studies.component.scss']
})

export class FavoriteStudiesComponent {
    @Input() favoriteStudies: IFavoriteStudies[] = [];

    constructor(public sessionService: SessionService, private router: Router,) { }

    // favouriteStudies = [
    //     { title: 'ABCDE 2024', id: 1, date: new Date(), description: 'Description for ABCDE 2024' },
    //     { title: 'ABCDE 2023', id: 2, date: new Date(), description: 'Description for ABCDE 2023' },
    //     { title: 'ABCDE 2022', id: 3, date: new Date(), description: 'Description for ABCDE 2022' },
    //     { title: 'ABCDE 2021', id: 4, date: new Date(), description: 'Description for ABCDE 2021' },
    //     { title: 'ABCDE 2020', id: 5, date: new Date(), description: 'Description for ABCDE 2020' }
    // ]

    onStudyClick(study: IFavoriteStudies): void {
        this.sessionService.setSession('engagementId', study.engagementId.toString());
        this.sessionService.setSession('clientId', study.clientId.toString());
        this.sessionService.setEngagementName(study.engagementName);
        this.sessionService.setEngagementNumber(study.engagementNumber);
        this.sessionService.setSession('clientName', study.clientName);

        this.router.navigate([ROUTE_URL.STUDYHOME(study.engagementId.toString())]);
    }
}